<template>
  <div class="fillcontain" >
    <head-top></head-top>
    <div class="select_container">
      <el-button type="primary" style="float: right" @click="addFormVisible = true">添加分类</el-button>
    </div>
    <div class="table_container">
      <el-table
        :data="tableData"
        highlight-current-row
        style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          label="分类名称"
          prop="categoryName">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100">
          <template slot-scope="scope">
            <el-button @click="Editmaterial(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelete(scope.$index, scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>


      <!--添加分类-->
      <el-dialog title="添加分类" :visible.sync="addFormVisible" v-loading="loading">
        <el-form :model="addForm" label-width="80px" ref="addForm">
          <el-form-item label="分类名称" prop="name">
            <el-input v-model="addForm.name" auto-complete="off" maxlength="6"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="cancel">取消</el-button>
          <el-button type="primary" @click="addSubmit()" >提交</el-button>
        </div>
      </el-dialog>

      <!--编辑分类-->
      <el-dialog title="修改分类" :visible.sync="addFormVisible2" v-loading="loading">
        <el-form :model="addForms" label-width="80px" ref="addForm">
          <el-form-item label="分类名称" prop="name">
            <el-input v-model="addForms.name" auto-complete="off" maxlength="6" ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible2 = false">取消</el-button>
          <el-button type="primary" @click="addSubmits()" >提交</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getPatclassification,getPictureAdd,getPictureMod,getPictureDel } from "../api/api"
  export default {
    data(){
      return {
        tableData: [],
        currentPage:1,
        limit: 20,
        total: 0,
        addFormVisible: false,//新增界面是否显示
        addFormVisible2: false,
        //新增界面数据
        addForm: {
          name:''
        },
        addForms: {},
        loading:false
      }
    },
    components: {
      headTop,
    },
    created(){
      this.getPatclassification()
    },

    methods: {
      getPatclassification(){
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
        };
        //获取图案分类列表
        getPatclassification(params).then(res=>{
          this.total = res.total
          this.tableData = res.pageInfo
        }).catch(error=>{
          console.log(error);
        })
      },
      addSubmit(){
        if (this.addForm.name == ''){
          this.$message({
            type: 'error',
            message: '请填写分类名称'
          });
        } else {
          this.loading = true
          let params={
            categoryName:this.addForm.name.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g,''),
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
          };
          //图片分类添加
          getPictureAdd(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.loading = false
              this.addForm = {}
              this.addFormVisible = false
              this.getPatclassification()
            }else {
              this.$message({
                type: 'error',
                message: '请上传正确信息'
              });
              this.loading = false
            }
          }).catch(error=>{
            this.loading = false
           console.log(error)
          })
        }
      },
      cancel(){
        this.addForm = {}
        this.addFormVisible = false
      },
      Editmaterial(index,row){
      //  编辑
        console.log(row)
        this.addFormVisible2 = true
        this.addForms.name = row.categoryName
        this.addForms.categoryId = row.categoryId
        this.addForms.operationId = JSON.parse(sessionStorage.getItem('user')).id
      },
      addSubmits(){
        if (this.addForms.name == ''){
          this.$message({
            type: 'error',
            message: '请填写分类名称'
          });
        } else {
          this.loading = true
          let params={
            categoryName:this.addForms.name.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g,''),
            categoryId:this.addForms.categoryId,
            operationId:this.addForms.operationId,
          };
          //图片分类添加
          getPictureMod(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.loading = false
              this.addForms = {}
              this.addFormVisible2 = false
              this.getPatclassification()
            }else {
              this.$message({
                type: 'error',
                message: '请上传正确信息'
              });
              this.loading = false
            }
          }).catch(error=>{
            this.loading = false
            console.log(error)
          })
        }
      },
      handleDelete(index, row){
        //删除分类
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params={
            categoryId:row.categoryId,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
          };
          getPictureDel(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.tableData.splice(index, 1);
            }else{
              throw new Error(res.message)
            }
          }).catch(error=>{
            this.$message({
              type: 'error',
              message: res.msg
            });
          })
        })
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getPatclassification()
      },

    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .el-dialog--small {
    width: 25%;
  }
</style>




// WEBPACK FOOTER //
// src/page/patFication.vue